module.exports = {"id":"200818","name":"Bruno Uvini","rating":"72","photo":"./data/images/photos/0/200818.png","club":{"name":"Al Nassr","logo":"./data/images/clubs/AlNassr.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BrunoUvini0.json
// module id = 667
// module chunks = 0